import { useEffect, useState } from 'react';

/**
 * Custom hook for client-side only rendering.
 * Returns true only after component has mounted on the client.
 * Prevents hydration mismatches in SSR by ensuring consistent
 * rendering between server and client.
 *
 * @returns {boolean} - true if rendered on client, false on server
 */
export function useClientRender() {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    return isClient;
}
